import {useCallback, useEffect, useState} from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { getPlan, updateTask } from '../../utils/api';

import Header from '../header/Header';

import './Plan.css';

function Plan({ handleConfetti, handleError, handleFeedback, handlePath, handleStartOver }) {
  const navigate = useNavigate();
  const { taskId } = useParams();

  const [expanded, setExpanded] = useState(null);
  const [plan, setPlan] = useState(null);

  const getPlanData = useCallback(async () => {
    try {
      const data = await getPlan();

      setPlan(data);

      if (taskId && data?.length) {
        const planIndex = data.findIndex(plan => plan.tasks?.some(task => task._id === taskId));

        if (planIndex >= 0) {
          setExpanded(planIndex);
          handleConfetti();
        }
      }
    } catch (e) {
      handleError(e);
    }
  }, [handleConfetti, handleError, taskId]);

  const handleChat = useCallback(() => {
    navigate('/chat');
  }, [navigate]);

  const handleExpand = useCallback((index) => {
    setExpanded(prevIndex => (prevIndex === index ? null : index));
  }, []);

  const handleTask = useCallback(async (task) => {
    const isCompleted = (task.status === 'completed');
    const path = '/activity/' + task.activityId;

    if (isCompleted) {
      navigate(path);
    } else {
      try {
        const response = await updateTask(task._id, 'completed');

        if (response !== null) {
          handleConfetti();
          
          navigate(path + '/' + task._id);
        }
      } catch (e) {
        handleError(e);
      }
    }
  }, [handleConfetti, handleError, navigate]);

  useEffect(() => {
    getPlanData();
  }, [getPlanData]);

  return (
    <>
      <Header activeElement="plan" handleFeedback={handleFeedback} handlePath={handlePath} handleStartOver={handleStartOver} />
      <div id="plan">
        <div id="details" className={'overflow' + (plan === null ? ' loading' : '')}>
          <div className="clamp">
            <div className="close light" onClick={handlePath}></div>
            {plan !== null ? (
              <>
                <div className="section-title">Your Plan</div>
                {plan?.length ? plan.map((item, itemIndex) => {
                  return (
                    <div key={itemIndex} className={'plan-item-container ' + item.category + (expanded === itemIndex ? ' expanded' : '')}>
                      <div className="plan-item" onClick={() => handleExpand(itemIndex)}>
                        <div className="plan-icon"></div>
                        <div className="plan-info">
                          <div className="plan-header">
                            <div className="plan-title">{item.title}</div>
                            <div className="plan-percentage">{parseInt((item.tasks.length ? item.tasks.filter(i => i.status === 'completed').length / item.tasks.length : 0) * 100, 10)}%</div>
                          </div>
                          <div className="plan-progress-container">
                            <div className="plan-progress" style={{ width: ((item.tasks.length ? item.tasks.filter(i => i.status === 'completed').length / item.tasks.length : 0) * 100) + '%' }}></div>
                          </div>
                          <div className="plan-tasks">{item.tasks.filter(i => i.status === 'completed').length} of {item.tasks.length} tasks completed</div>
                        </div>
                      </div>
                      <div className="plan-details">
                        {item.tasks.filter(i => i.status === 'completed').length ? (
                          <>
                            <div className="plan-details-title">Things you've already done!</div>
                            <div className="plan-details-list completed">
                              {item.tasks.filter(i => i.status === 'completed').sort((a, b) => a.order - b.order).map((task, taskIndex) => {
                                return (
                                  <div key={taskIndex} className="plan-details-list-item" onClick={() => handleTask(task)}>{task.title}</div>
                                );
                              })}
                            </div>
                          </>
                        ) : null}
                        {item.tasks.filter(i => i.status !== 'completed').length ? (
                          <>
                            <div className="plan-details-title">Next Steps</div>
                            <div className="plan-details-list">
                              {item.tasks.filter(i => i.status !== 'completed').sort((a, b) => a.order - b.order).map((task, taskIndex) => {
                                return (
                                  <div key={taskIndex} className="plan-details-list-item" onClick={() => handleTask(task)}>{task.title}</div>
                                );
                              })}
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  );
                }) : null}
              </>
            ) : (
              <div className="callout">
                <div>Thanks! Building your personalized plan now...</div>
                <div className="callout-progress-container">
                  <div className="callout-progress"></div>
                </div>
              </div>
            )}
          </div>
          </div>
        <div id="chat-button" onClick={handleChat}></div>
      </div>
    </>
  );
}

export default Plan;
